import {
  EXPORT_PCA_REPORT,
  EXPORT_PCA_REPORT_SUCCESS,
  EXPORT_PCA_REPORT_FAILURE,
  RESET_EXPORT_PCA_REPORT,

  PCA_FIND_CM,
  PCA_FIND_CM_SUCCESS,
  PCA_FIND_CM_FAILURE,
  RESET_PCA_FIND_CM,

  PCA_FETCH_ALL_ACTIVE_SKILLS,
  PCA_FETCH_ALL_ACTIVE_SKILLS_SUCCESS,
  PCA_FETCH_ALL_ACTIVE_SKILLS_FAILURE,

  CREATE_PCA_RECORD,
  CREATE_PCA_RECORD_SUCCESS,
  CREATE_PCA_RECORD_FAILURE,
  RESET_CREATE_PCA_RECORD,

  GET_ALL_REGISTERED_CM_PCA,
  GET_ALL_REGISTERED_CM_SUCCESS_PCA,
  GET_ALL_REGISTERED_CM_FAILURE_PCA,

  GET_CM_PCA_BY_ID,
  GET_CM_PCA_BY_ID_SUCCESS,
  GET_CM_PCA_BY_ID_FAILURE,
  GET_CM_PCA_BY_ID_RESET,

  EDIT_PCA_DATA,
  EDIT_PCA_DATA_SUCCESS,
  EDIT_PCA_DATA_FAILURE,
  EDIT_PCA_DATA_RESET,

} from "../ActionTypes";

export const exportPcaReport = () => ({
  type: EXPORT_PCA_REPORT
})

export const exportPcaReportSuccess = () => ({
  type: EXPORT_PCA_REPORT_SUCCESS
})

export const exportPcaReportFailure = ({ payload }) => ({
  type: EXPORT_PCA_REPORT_FAILURE,
  payload
})

export const resetExportPcaReport = ({ payload }) => ({
  type: RESET_EXPORT_PCA_REPORT,
  payload
})

export const pcaFindCm = (payload) => ({
  type: PCA_FIND_CM,
  payload
})

export const pcaFindCmSuccess = (payload) => ({
  type: PCA_FIND_CM_SUCCESS,
  payload
})

export const pcaFindCmFailure = (payload) => ({
  type: PCA_FIND_CM_FAILURE,
  payload
})

export const resetPcaFindCm = (payload) => ({
  type: RESET_PCA_FIND_CM,
  payload
})

export const pcaFetchAllActiveSkills = payload => ({
  type: PCA_FETCH_ALL_ACTIVE_SKILLS,
  payload
})

export const pcaFetchAllActiveSkillsSuccess = payload => ({
  type: PCA_FETCH_ALL_ACTIVE_SKILLS_SUCCESS,
  payload
})

export const pcaFetchAllActiveSkillsFailure = payload => ({
  type: PCA_FETCH_ALL_ACTIVE_SKILLS_FAILURE,
  payload
})

export const createPcaRecord = payload => ({
  type: CREATE_PCA_RECORD,
  payload
})

export const createPcaRecordSuccess = payload => ({
  type: CREATE_PCA_RECORD_SUCCESS,
  payload
})

export const createPcaRecordFailure = payload => ({
  type: CREATE_PCA_RECORD_FAILURE,
  payload
})

export const resetCreatePcaRecord = payload => ({
  type: RESET_CREATE_PCA_RECORD,
  payload
})


export const getAllRegisteredCmPca = payload => ({
  type: GET_ALL_REGISTERED_CM_PCA,
  payload
})

export const getAllRegisteredCmSuccessPca = payload => ({
  type: GET_ALL_REGISTERED_CM_SUCCESS_PCA,
  payload
})

export const getAllRegisteredCmFailurePca = payload => ({
  type: GET_ALL_REGISTERED_CM_FAILURE_PCA,
  payload
})

export const getCmPcaById = id => ({
  type: GET_CM_PCA_BY_ID,
  id
})

export const getCmPcaByIdSuccess = payload => ({
  type: GET_CM_PCA_BY_ID_SUCCESS,
  payload
})

export const getCmPcaByIdFailure = payload => ({
  type: GET_CM_PCA_BY_ID_FAILURE,
  payload
})

export const getCmPcaByIdReset = payload => ({
  type: GET_CM_PCA_BY_ID_RESET,
  payload
})

export const editPcaData = payload => ({
  type: EDIT_PCA_DATA,
  payload
})

export const editPcaDataSuccess = payload => ({
  type: EDIT_PCA_DATA_SUCCESS,
  payload
})

export const editPcaDataFailure = payload => ({
  type: EDIT_PCA_DATA_FAILURE,
  payload
})

export const editPcaDataReset = payload => ({
  type: EDIT_PCA_DATA_RESET,
  payload
})

